var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"background"}),_c('div',{staticClass:"outer-wrapper"},[_c('div',{staticClass:"player-wrapper"},[_c('VimeoPlayer',{attrs:{"theme":"theatre","videoId":_vm.videoId}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }